@file:Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")

package com.wintermar.inspection.feature.domain.usecase.inspection

import com.wintermar.inspection.core.data.AppSetting
import com.wintermar.inspection.core.domain.FlowResult
import com.wintermar.inspection.feature.domain.model.inspection.InspectionModel
import com.wintermar.inspection.feature.domain.model.template.TemplateOptionModel
import com.wintermar.inspection.feature.domain.repository.InspectionRepository
import com.wintermar.inspection.feature.domain.repository.TemplateRepository
import com.wintermar.inspection.feature.domain.repository.answer.AnswerRepository
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow
import kotlinx.coroutines.flow.flowOn

actual class GetInspectionDetailUseCaseImpl actual constructor(
    private val inspectionRepository: InspectionRepository,
    private val answerRepository: AnswerRepository,
    private val templateRepository: TemplateRepository,
    private val appSetting: AppSetting
) : GetInspectionDetailUseCase {
    actual override operator fun invoke(
        inspectionId: String,
        templateOptions: List<TemplateOptionModel>
    ): Flow<FlowResult<InspectionModel>> = flow {
        emit(FlowResult.Loading(showLoading = true))

        inspectionRepository.getInspectionById(
            id = inspectionId,
            userFullName = appSetting.userFullName ?: "",
            templateOptions = templateOptions
        ).collect { result ->
            if (result is FlowResult.Success) {
                val inspection = result.data ?: return@collect
                val updatedInspection = inspection.copy(
                    totalAnswer = inspection.template.getTotalAnswer()
                )
                emit(FlowResult.Success(updatedInspection))
            } else {
                emit(result)
            }
        }

        emit(FlowResult.Loading(showLoading = false))
    }.flowOn(Dispatchers.Default)
}
